import { createSignal, createEffect, onCleanup, type Accessor } from "solid-js";

/**
 * The view (MAP / TABLE / SCATTER / TIME SERIES / VIDEO) the mounted maneuver report page is
 * actually showing.
 *
 * `selectedPage()` only tracks the sidebar SUBMENU: every maneuver page's own View dropdown calls
 * setView() without writing it back, so after a dropdown switch selectedPage is stale. The sidebar
 * chart search needs the real view, so each maneuver page mirrors its view signal here.
 */
const [activeManeuverView, setActiveManeuverView] = createSignal<string | null>(null);

/** The page that wrote last; split view can mount two maneuver pages at once. */
let lastWriter: symbol | null = null;

export { activeManeuverView };

/**
 * Mirror a maneuver page's view signal for as long as the calling component is mounted.
 * Cleanup only clears the value when this page was the last writer.
 */
export function useActiveManeuverViewMirror(view: Accessor<string>): void {
  const writer = Symbol("maneuver-view-writer");
  createEffect(() => {
    setActiveManeuverView(view());
    lastWriter = writer;
  });
  onCleanup(() => {
    if (lastWriter === writer) {
      setActiveManeuverView(null);
      lastWriter = null;
    }
  });
}
